module.exports = __webpack_public_path__ + "img/amd.f3ff0811.svg";